import * as React from 'react'
import Typography from '../Typography'

const SubmissionMessage = () => (
  <Typography className="leshen-form-submission-message" variant="body">
    Thank you for your submission.
  </Typography>
)

export default SubmissionMessage
